<div *ngIf="currency$ | async as prefCurrency" class="potential-revenue">
  <ng-container *ngIf="(isPotentialRevenueLoaded$ | async) === true; else loading">
    <div *ngIf="showMonthlyRevenue$ | async" class="metric">
      <div>
        {{ selectedDate$ | async | monthYear }}
        {{ 'FRONTEND.SALES_UI.PROJECTED_MONTHLY_REVENUE' | translate }}:
      </div>
      <div class="value">
        {{ monthlyRevenue$ | async | formatCurrency : prefCurrency }}
      </div>
      <div *ngIf="(monthlyWeightedRevenue$ | async) > 0" class="value">
        <mat-icon>balance</mat-icon>
        {{ monthlyWeightedRevenue$ | async | formatCurrency : prefCurrency }}
      </div>
    </div>
    <div class="metric">
      <div>{{ 'FRONTEND.SALES_UI.PIPELINE.POTENTIAL_REVENUE' | translate }}:</div>
      <div class="value">
        {{ potentialRevenue$ | async | formatCurrency : prefCurrency }}
      </div>
      <div *ngIf="(weightedPotentialRevenue$ | async) > 0" class="value">
        <mat-icon>balance</mat-icon>
        {{ weightedPotentialRevenue$ | async | formatCurrency : prefCurrency }}
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <mat-spinner [diameter]="16" [strokeWidth]="3" class="loading-spinner"></mat-spinner>
</ng-template>
